var SENTRY_RELEASE;SENTRY_RELEASE={name: "Vocalise", version: "0.24.8"};